module.exports = __webpack_public_path__ + "img/laptop_charts.53a08380.jpg";